export function documentCanCopy() {
    return (
        document.queryCommandSupported && document.queryCommandSupported('copy')
    );
}
export function executeCopy() {
    document.execCommand('copy');
}
